export default {
    name: 'reportsPallets',
    component: () => import(/* webpackChunkName: "reports-pallets-Layout" */ '@/modules/reports/pallets/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.reports.pallets.index',
            component: () => import(/* webpackChunkName: "reports-pallets-index" */ '@/modules/reports/pallets/views/Index'),
        },
    ]
}